export default __webpack_public_path__ + "static/Designer-54a149667d15ff2f9f770dbb1773aa03.webp";